import { AdTabProps } from "./config/tab";
import { memo, PropsWithChildren, useCallback } from "react";
import { useExperiment } from "@/common/hooks/useExperiment";
import { Button } from "@rg/ui/components/Button";
import { EXPERIMENT_NO_ADS } from "@/common/services/experiment/constants";
import "./AdTab.scss";

const AdTab = ({ link, children, onClick }: AdTabProps & PropsWithChildren & { onClick?: () => void }) => {
  const { isLoading, variant: noAds } = useExperiment({ key: EXPERIMENT_NO_ADS, fallback: false });

  const handleClick = useCallback(() => {
    onClick?.();
    window.open(link, "_blank", "noopener");
  }, [link, onClick]);

  if (noAds || isLoading) {
    return null;
  }

  return (
    <Button className="aTab" variant="tertiary" size="md" onClick={handleClick}>{children}</Button>
  );
};

const adTabMemo = memo(AdTab);

export default adTabMemo;
